/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingGroupByDetails {
    getFixupPrototypeFunction() { return BillingGroupByDetails.fixupPrototype; }

    static newInstance(model: Partial<BillingGroupByDetails>): BillingGroupByDetails {
        let obj = Object.assign(new BillingGroupByDetails(), model);
        BillingGroupByDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingGroupByDetails>): BillingGroupByDetails {
        if (!model) return null;
        return BillingGroupByDetails.newInstance(<BillingGroupByDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingGroupByDetails) {
        if (!obj) return;

        models.BillingGroupByDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingGroupByDetails): boolean {
        Object.setPrototypeOf(obj, BillingGroupByDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.groups) {
            for (let val of this.groups) {
                models.BillingCustomGroup.fixupPrototype(val);
            }
        }
    }

    /**
     * Dimension to group results by
     */
    selector: models.BillingGroupBySelector;

    /**
     * Key to use with Extras, Tags, Hierarchy, and Dimension
     */
    key: string;

    /**
     * Value to use with Extras, Tags and Hierarchy
     */
    value: string;

    /**
     * Value to use in Tags
     */
    kind: string;

    /**
     * List of custom groups to use with Dimension
     */
    groups: Array<models.BillingCustomGroup>;

}
